import Aactions from '@/components/Aactions';
import Aempty from '@/components/Aempty';
import Aenume from '@/components/Aenume';
import AfSearch from '@/components/Aform/AfSearch';
import BfSearch from '@/components/Aform/BfSearch';
import AformItem from '@/components/AformItem';
import Apages from '@/components/Apages';
import Apopconfirm from '@/components/Apopconfirm';
import './index.css';

export default {
  name: 'Btable',
  components: {
    Aactions,
    Aempty,
    Aenume,
    AfSearch,
    BfSearch,
    AformItem,
    Apages,
    Apopconfirm,
  },
  props: {
    margin: { type: String, default: () => '0' },
    rowKey: { type: String, default: () => 'id' },
    size: { type: String, default: () => 'medium' },
    selectionWidth: { type: String, default: () => '50' },
    sort: { type: Boolean, default: () => true },
    sortTitle: { type: String, default: () => '#' },
    sortWidth: { type: String, default: () => '50' },
    border: { type: Boolean, default: () => false },
    stripe: { type: Boolean, default: () => false },
    loading: { type: Boolean, default: () => false },
    column: { type: Array, default: () => [] },
    record: { type: Object, default: () => ({}) },
    maxHeight: { type: String, default: () => '480' },
    elementLoadingText: { type: String, default: () => '' },
    elementLoadingSpinner: { type: String, default: () => 'el-icon-loading' },
    elementLoadingBackground: { type: String, default: () => 'rgba(0, 0, 0, 0.04)' },
    emptyText: { type: String, default: () => '' },
    showHeader: { type: Boolean, default: () => true },
    selection: { type: Boolean, default: () => true },
    showOverflowTooltip: { type: Boolean, default: () => true },
    tooltipEffect: { type: String, default: () => 'light' },
    showSummary: { type: Boolean, default: () => false },
    sumText: { type: String, default: () => '合计' },
    sortable: { type: Boolean, default: () => false },
    defaultSort: { type: Object, default: () => ({ prop: 'date', order: 'descending' }) },
    tree: { type: Boolean, default: () => false },
    defaultExpandAll: { type: Boolean, default: () => true },
    treeProps: { type: Object, default: () => ({ children: 'children', hasChildren: 'hasChildren' }) },
    highlightCurrentRow: { type: Boolean, default: () => false },
    action: { type: Object, default: () => ({ review: null, modify: null, update: null, handle: null, remove: null, delete: null, export: null }) },
    actionWidth: { type: String, default: () => '180px' },
    actionTitle: { type: String, default: () => '操作' },
    page: { type: Boolean, default: () => false },
  },
  mounted() {
    this.$refs['b-table'].bodyWrapper.addEventListener('wheel', this.scroll);
  },
  beforeDestroy() {
    this.$refs['b-table'].bodyWrapper.removeEventListener('wheel', this.scroll);
  },
  destroyed() {
    this.create = null;
    this.search = null;
    this.select = null;
    this.choose = null;
    this.change = null;
    this.format = null;
    this.scroll = null;
  },
  methods: {
    create() {
      let column = [...this.column, this.suffix()];
      return column.map((a, b) => this.output(a, b));
    },
    output(a, b) {
      if (a && Object.keys(a).length > 0) {
        const { type = null, render = null, header = null, ...r } = a;
        let child = a.children || a.child || a.node || a.list || [];
        let field = a.field || a.index || a.name || a.prop;
        let label = a.label || a.title || a.text;
        let attrs = {
          key: b,
          prop: field,
          scopedSlot: field,
          sortable: field ? (a.sortable ? a.sortable : this.sortable) : false,
          formatter: render ? render : (type ? ((e, f, g, h) => this.format(a, b, e, h)) : null),
          showOverflowTooltip: a.showOverflowTooltip ? a.showOverflowTooltip : this.showOverflowTooltip,
          ...r
        };
        if (child.length > 0) {
          return (
            <el-table-column key={b} label={label}>
              {child.map((c, d) => this.output(c, `${b}-${d}`))}
            </el-table-column>
          );
        } else {
          return (
            <el-table-column {...{ attrs }}>
              <template slot="header">
                {header ? () => header(r) : (label && label != '' && label.length && label.length > 8 ? (
                  <el-tooltip content={label} placement="top">
                    <span title={label}>{label}</span>
                  </el-tooltip>
                ) : <span title={label}>{label}</span>)}
              </template>
            </el-table-column>
          );
        }
      }
    },
    suffix() {
      if (
        this.action.review ||
        this.action.modify ||
        this.action.update ||
        this.action.handle ||
        this.action.remove ||
        this.action.delete ||
        this.action.export ||
        this.$listeners.review ||
        this.$listeners.modify ||
        this.$listeners.update ||
        this.$listeners.handle ||
        this.$listeners.remove ||
        this.$listeners.delete ||
        this.$listeners.export
      ) {
        return ({
          fixed: 'right',
          align: 'center',
          width: this.actionWidth,
          label: this.actionTitle,
          formatter: (item) => (
            <div class="action">
              {this.action.review && <i class="el-icon-view" on-click={() => this.action.review(item)} />}
              {this.action.modify && <i class="el-icon-edit" on-click={() => this.action.modify(item)} />}
              {this.action.update && <i class="el-icon-edit" on-click={() => this.action.update(item)} />}
              {this.action.handle && <i class="el-icon-edit" on-click={() => this.action.handle(item)} />}
              {this.action.remove && <Apopconfirm on-submit={() => this.action.remove(item)} />}
              {this.action.delete && <Apopconfirm on-submit={() => this.action.delete(item)} />}
              {this.action.export && <i class="el-icon-download" on-click={() => this.action.export(item)} />}
              {this.$listeners.review && <i class="el-icon-view" on-click={() => this.$listeners.review(item)} />}
              {this.$listeners.modify && <i class="el-icon-edit" on-click={() => this.$listeners.modify(item)} />}
              {this.$listeners.update && <i class="el-icon-edit" on-click={() => this.$listeners.update(item)} />}
              {this.$listeners.handle && <i class="el-icon-edit" on-click={() => this.$listeners.handle(item)} />}
              {this.$listeners.remove && <Apopconfirm on-submit={() => this.$listeners.remove(item)} />}
              {this.$listeners.delete && <Apopconfirm on-submit={() => this.$listeners.delete(item)} />}
              {this.$listeners.export && <i class="el-icon-download" on-click={() => this.$listeners.export(item)} />}
            </div>
          ),
        });
      }
    },
    search(params = {}) {
      this.$emit('search', params);
    },
    select(items = []) {
      this.$emit('select', items);
    },
    choose(row, column, event) {
      this.$emit('choose', { row, column, event });
    },
    change(pages = { page: 1, size: 10 }) {
      this.$emit('change', pages);
      this.search(pages);
    },
    format({ type = '', name = '', data = [], text = '', label = '', title = '', field = '', dicts = [], ...props }, colIndex, item, rowIndex) {
      if (type == 'enume' || type == 'enumerate') {
        if (field != '') return (<Aenume key={colIndex + '-' + rowIndex} v-model={item[field]} field={field} data={dicts.length > 0 ? dicts : data} {...props} />);
        return (<Aenume key={colIndex + '-' + rowIndex} v-model={item[name]} field={name} data={dicts.length > 0 ? dicts : data} {...props} />);
      }
      return (
        <AformItem
          key={colIndex + '-' + rowIndex}
          config={{
            type,
            form: item,
            dicts: dicts.length > 0 ? dicts : data,
            field: field != '' ? field : (name != '' ? name : ''),
            label: text != '' ? text : (label != '' ? label : (title != '' ? title : '无栏目名称')),
            ...props
          }}
        />
      );
    },
    scroll(a) {
      let container = this.$refs['b-table'].bodyWrapper;
      if (container) {
        if (container.scrollHeight > container.clientHeight) {
          a.preventDefault();
          container.scrollTop += a.deltaY;
        } else {
          if (container.scrollWidth > container.clientWidth) {
            a.preventDefault();
            container.scrollLeft += a.deltaY;
          }
        }
        this.$emit('scroll', a);
      }
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    const { ...r } = this.record;
    const data = r.data ? r.data : (r.list ? r.list : (r.rows ? r.rows : (r.record ? r.record : (r.records ? r.records : []))));
    const size = r.size ? r.size : (r.total ? r.total : (r.count ? r.count : 0));
    const condition = data.length > 0;
    return (
      <div style={{ padding: this.margin }}>
        <div class={['b-table', (this.border ? 'border' : null)]}>
          <el-table
            ref="b-table"
            data={data}
            size={this.size}
            v-loading={this.loading}
            border={this.border}
            stripe={this.stripe}
            row-key={this.rowKey}
            on-row-click={this.choose}
            max-height={this.maxHeight}
            element-loading-text={this.elementLoadingText}
            element-loading-spinner={this.elementLoadingSpinner}
            element-loading-background={this.elementLoadingBackground}
            show-header={this.showHeader}
            default-sort={this.defaultSort}
            show-summary={this.showSummary}
            on-selection-change={this.select}
            tooltip-effect={this.tooltipEffect}
            default-expand-all={this.defaultExpandAll}
            tree-props={this.tree ? this.treeProps : {}}
            highlight-current-row={this.highlightCurrentRow}
            {...{ attrs }}
          >
            {(condition && (this.selection || this.$listeners.select)) && <el-table-column fixed="left" type="selection" width={this.selectionWidth} />}
            {(condition && this.sort) && <el-table-column fixed="left" type="index" width={this.sortWidth} label={this.sortTitle} />}
            {condition && this.create()}
            {condition && this.$slots.default}
            <div slot="empty" class="empty">{!this.loading && <Aempty description={this.emptyText} />}</div>
          </el-table>
          {!this.tree && this.page && condition && (<Apages total={Number(size)} on-change={this.change} />)}
        </div>
      </div>
    );
  }
}